<template>
  <svg class="stairs" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 485 485" fill="none">
    <path d="M323.335 0V164.762H161.665V329.523H0V485H485V0H323.335Z" fill="white" />
  </svg>
</template>
